import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";

export const usePrefetchPdf = (deps: {
  invoiceId: string;
  canGoNext: boolean;
  canGoBack: boolean;
  currentQueueIndex: number;
  fetchPdf: (id: string) => Promise<{ blob: string; url: string }>;
  getElementOnQueue: (index: number) => string | null;
  setErrorMessage: (message: string) => void;
}) => {
  const [pdf, setPdf] = useState<{ blob: string | null; url: string | null }>({
    blob: null,
    url: null,
  });
  const {
    fetchPdf,
    invoiceId,
    canGoNext,
    canGoBack,
    getElementOnQueue,
    currentQueueIndex,
    setErrorMessage,
  } = deps;

  useEffect(() => {
    if (!invoiceId) return;

    // setPdf({ blob: null, url: null });

    let isCanceled = false;

    const prefetchPdfs = async () => {
      try {
        const pdfBlob = await fetchPdf(invoiceId);
        if (!isCanceled) {
          setPdf(pdfBlob);
        }

        setTimeout(() => {
          if (!isCanceled && canGoNext) {
            const element = getElementOnQueue(currentQueueIndex + 1);
            if (element) fetchPdf(element);
          }
          if (!isCanceled && canGoBack) {
            const element = getElementOnQueue(currentQueueIndex - 1);
            if (element) fetchPdf(element);
          }
        }, 2000);
      } catch (error) {
        Sentry.captureException(error);
        setErrorMessage(
          "Beim ausgewähltem Unternehmen gibt es diese Rechnung nicht. Sie können nur ein Unternehmen auf einmal öffnen. Überprüfen Sie ob bereits eines in einem anderen Fenster/Tab geöffnet ist.",
        );
      }
    };

    prefetchPdfs();

    return () => {
      isCanceled = true;
    };
  }, [invoiceId, canGoNext, canGoBack, currentQueueIndex]);

  return pdf;
};
